import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { StepIngressarAtendEnum as StepIngressarAtend } from '../../../interfaces/enum/StepIngressarAtendEnum';
import FilaPAVirtual from './FilaPAVirtual';
import StartIngressarAtend from './StartIngressarAtend';
import StepAguardarFinalizacaoAtendimento from './StepAguardarFinalizacaoAtendimento';
import StepRedirectZoom from './StepRedirectZoom';
import StepValidarBiometriaFacial from './StepValidarBiometriaFacial';
import './styles.css';
import './sxProps';

const IngressarNoAtendimento: React.FC = () => {

  const [step, setStep] = useState<number>(StepIngressarAtend.FilaPaVirtual);
  const { idReuniao, paVirtual } = useParams(); //idReuniao está tendo como valor o idAgenda para PA Virtual, por isso variável auxiliar idReuniaoPaVirtual
  const [zoomUrl, setZoomUrl] = useState('');
  const [idReuniaoPaVirtual, setIdReuniaoPaVirtual] = useState<string>('');

  useEffect(() => {
    let isPaVirtual = !!paVirtual;
    if (!isPaVirtual) {
      setStep(StepIngressarAtend.ValidarBiometriaFacial);
    }
  }, []);

  return (
    <>
      <div className='telessaude-wrapper'>
        {step === StepIngressarAtend.FilaPaVirtual &&
          <FilaPAVirtual
            nextStep={() => setStep(StepIngressarAtend.StartIngressarAtend)}
            idAgenda={idReuniao || ''}
            fillIdReuniaoPaVirtual={(idReuniao) => setIdReuniaoPaVirtual(idReuniao)}
          />}
        {step === StepIngressarAtend.StartIngressarAtend &&
          <StartIngressarAtend nextStep={() => setStep(StepIngressarAtend.ValidarBiometriaFacial)} />}
        {step === StepIngressarAtend.ValidarBiometriaFacial &&
          <StepValidarBiometriaFacial nextStep={() => setStep(StepIngressarAtend.RedirectZoom)} />}
        {step === StepIngressarAtend.RedirectZoom &&
          <StepRedirectZoom
            nextStep={() => setStep(StepIngressarAtend.AguardarFinalizacaoAtendimento)}
            idReuniao={idReuniaoPaVirtual || idReuniao}
            idAgenda={idReuniao}
            setZoomUrl={(url) => setZoomUrl(url)}
          />}
        {step === StepIngressarAtend.AguardarFinalizacaoAtendimento &&
          <StepAguardarFinalizacaoAtendimento
            nextStep={() => setStep(StepIngressarAtend.ConfirmarFinalizacaoAtendimento)}
            idReuniao={idReuniaoPaVirtual || idReuniao} zoomUrl={zoomUrl}
          />}
      </div>
    </>
  )
}

export default IngressarNoAtendimento;